import DashboardLayout from "../ManagementLayout";
import ManagementPage from "../../ui/ManagementDashboard";

export default function ManagementDashboard() {

  return (
    <DashboardLayout>
      <ManagementPage/>
    </DashboardLayout>
  );
}